import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";

export const SILK = {
  flow: "/silk/silk-flow.jpg",
  scarf: "/silk/silk-scarf.jpg",
  ribbon: "/silk/silk-ribbon.jpg",
};

const POS = {
  right: "right-[-14%] sm:right-[-6%] top-[-4%] w-[70vw] sm:w-[44vw] lg:w-[30vw]",
  left: "left-[-14%] sm:left-[-6%] top-[-6%] w-[70vw] sm:w-[46vw] lg:w-[34vw]",
  center: "left-1/2 -translate-x-1/2 top-[-8%] w-[90vw] sm:w-[60vw]",
};

export default function SilkTexture({ src = SILK.flow, side = "right", opacity = 0.32, speed = 60, blend = "multiply", className = "" }) {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [reduce ? 0 : -speed, reduce ? 0 : speed]);
  return (
    <div ref={ref} aria-hidden="true" className={`absolute inset-0 overflow-hidden pointer-events-none silk-fade ${className}`}>
      <motion.img
        src={src}
        alt=""
        loading="lazy"
        style={{ y, opacity, mixBlendMode: blend }}
        className={`absolute ${POS[side]} aspect-[2/3] object-cover silk-mask`}
      />
    </div>
  );
}
